module.exports = __webpack_public_path__ + "media/images/logos/post-1f669f07c673a5ebe0600e1d65a1469a.svg";